import { render, staticRenderFns } from "./CustomQuestionAnswerDropdown.vue?vue&type=template&id=48df8df3"
import script from "./CustomQuestionAnswerDropdown.vue?vue&type=script&lang=js"
export * from "./CustomQuestionAnswerDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports